module.exports = __webpack_public_path__ + "static/media/qa.bd36e4cb.svg";